import { ResumeChat } from "./resume_chat";

export class ResumeChats extends Array<ResumeChat> {
  constructor(resumeChats?: ResumeChat[]) {
    super();
    if (resumeChats instanceof Array) {
      resumeChats.forEach((resumeChat) => this.push(resumeChat));
    }
  }
}
